// node_modules
import { useEffect, useState } from "react";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";

export const usePagination = (amountOfResultsPerPage?: number, amountOfResults?: number, 
        onPaginate?: (newPageNumber: number) => void, isAllowedToPaginate?: () => boolean) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [amountOfPages, setAmountOfPages] = useState<number>(0);

    useEffect(() => {
        if(!amountOfResultsPerPage) return;
        
        if(!amountOfResults) {
            setAmountOfPages(0);
            setCurrentPage(1);
        } else {
            setAmountOfPages(Math.ceil(amountOfResults / amountOfResultsPerPage));
        }
    }, [amountOfResultsPerPage, amountOfResults]);

    const paginate = (newPageNumber: number) => {
        if(isAllowedToPaginate) {
            const isAllowed = isAllowedToPaginate();
            if(!isAllowed) return;
        }

        if (newPageNumber < 1) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "You cannot go further back than page 1.");
            return;
        }
        if (newPageNumber > amountOfPages) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "You cannot go further than then last page.");
            return;
        }

        setCurrentPage(newPageNumber);
        if(onPaginate) onPaginate(newPageNumber);
    };

    const paginateToPreviousPage = () => {
        const newPageNumber = currentPage - 1;
        paginate(newPageNumber);
    };

    const paginateToNextPage = () => {
        const newPageNumber = currentPage + 1;
        paginate(newPageNumber);
    };
    
    return { currentPage, amountOfPages, paginateToNextPage, paginateToPreviousPage };
};